// extracted by mini-css-extract-plugin
export default {"warningModalHeader":"WarningModalHeader_warningModalHeader__nOvF-"};